import { t } from "i18next"
import { capitalizeFirstLetter } from "utils"

const getUserData = (item, parentId) => {
  let obj
  if (item?.data) {
    obj = {
      ...item.data,
      id: item.data.userId,
      userId: item.data.userId,
      name: item.data.name,
      nameAr: item.data.nameAr,
      reporteesCount: item.data.totalMembers + " " + t("Members"),
      designation: item.data.designation,
      parentId: parentId,
      ...(item?.children && { children: item.children.map(e => getUserData(e, item.data.userId)) }),
    }
  } else {
    obj = {
      ...item,
      type: "region",
      id: item?.cities ? "region-" + item?.regionId : item?.cityId,
      name: item?.cityName || item.regionName,
      parentId: parentId,
      ...(item?.cities && {
        children: item.cities.map(e => getUserData(e, item?.cities ? "region-" + item?.regionId : item?.cityId)),
      }),
    }
  }
  return obj
}

export const forecastedProjectionTransformer = response => {
  let listKeys = []

  const forecastedTable = response?.forecasted_table || {}
  const staticKeys = forecastedTable?.staticKeys || {}

  const parentKeys = Object.keys(staticKeys)
    .map(parentKey => ({
      parentKey,
      order: staticKeys[parentKey]?.order ?? 0,
    }))
    .sort((a, b) => a.order - b.order)

  parentKeys.map(({ parentKey }) => {
    const children = Object.keys(staticKeys[parentKey] || {})
      .filter(childKey => {
        if (childKey === "order" || childKey === "label") return false
        const childValue = staticKeys[parentKey][childKey]
        return childValue && typeof childValue === "object" && !Array.isArray(childValue)
      })
      .map(childKey => {
        const { order, ...childData } = staticKeys[parentKey][childKey] || {}
        return {
          type: childData?.type || "number",
          ...childData,
          key: childKey,
          showPercentage: childData?.percentage || false,
          parent: parentKey,
          order: order ?? 0,
          short: childData?.short || childData?.label || capitalizeFirstLetter(childKey),
          label: childData?.label || t(capitalizeFirstLetter(childKey)),
        }
      })
      .sort((a, b) => a.order - b.order)
    if (children.length > 0) {
      listKeys.push({
        key: parentKey,
        label: staticKeys[parentKey]?.label || t(capitalizeFirstLetter(parentKey)),
        title: staticKeys[parentKey]?.label || t(capitalizeFirstLetter(parentKey)),
        children,
      })
    }
  })

  const userKpi = {
    ...forecastedTable,
    data:
      (forecastedTable?.data?.length > 0 &&
        forecastedTable.data.map(item => getUserData(item, item?.data?.userId || item?.regionId))) ||
      [],
  }

  return {
    ...response,
    listKeys,
    userKpi,
  }
}
